var map = {
	"./ab_testing/ab_testing_service.ts": 19871,
	"./ai_list/ai_list_service.ts": 86425,
	"./analytics/analytics_service.ts": 78805,
	"./analytics/casinofied_analytics_proxy_service.ts": 20771,
	"./bonus_abuse/bonus_abuse_parking_money_in_sport_and_poker_service.ts": 86559,
	"./cashier_proxy/cashier_proxy_service.ts": 33138,
	"./clock/clock_service.ts": 97856,
	"./component_factory/component_factory_service.js": 24600,
	"./config/config_service.ts": 89752,
	"./country/country_service.ts": 43508,
	"./currency/currency_service.ts": 95015,
	"./domain_detection/domain_detection_service.ts": 79198,
	"./evolution/evolution_service.ts": 50422,
	"./external_links_proxy/external_links_proxy_service.ts": 72025,
	"./game/game_runner_proxy_service.ts": 27296,
	"./game/game_service.js": 85993,
	"./game_manager/game_manager_service.js": 92480,
	"./game_reason/game_reason_service.js": 37405,
	"./games_correlation/games_correlation_service.js": 30780,
	"./games_information/games_information_service.ts": 868,
	"./games_questionnaire/games_questionnaire_service.ts": 45489,
	"./gnwp/gnwp_service.ts": 50419,
	"./history/history_service.ts": 21441,
	"./http/http2_service.ts": 84592,
	"./hybrid/hybrid_service.js": 25236,
	"./hybrid/hybrid_version_handler_service.js": 74125,
	"./idle_recommendations/idle_recommendations_service.ts": 60205,
	"./integration/integration_service.js": 51432,
	"./jackpot_toasters/jackpot_toasters_service.ts": 5915,
	"./language/language_service.ts": 25566,
	"./links_navigation_proxy/links_navigation_proxy_service.ts": 43845,
	"./live_feeds/jackpots/jackpot_feeds_service.ts": 62387,
	"./live_tables/live_tables_service.ts": 17733,
	"./message_manager/message_manager_service.ts": 45060,
	"./netent/netent_service.ts": 64376,
	"./oauth/oauth2_service.js": 82909,
	"./oauth/user/user_service.ts": 12642,
	"./observable_factory/observable_factory_service.ts": 54194,
	"./orbit_component_renderer/orbit_component_render_service.ts": 42586,
	"./overlay_manager/overlay_manager_service.ts": 47910,
	"./player-migration/player_migration_proxy_service.ts": 14809,
	"./player_messages_service/fallback/fallback_service.js": 36857,
	"./player_messages_service/firebase/firebase_elastic_service.ts": 59716,
	"./player_messages_service/player_messages_service.js": 86136,
	"./post_message/post_message_service.js": 96423,
	"./query_string_detector/query_string_detector_service.js": 77027,
	"./recently_played/recently_played_service.ts": 84265,
	"./regulation/regulation_service.js": 60382,
	"./resize_detector/resize_detector_service.js": 10108,
	"./restrictions/restrictions_service.ts": 40699,
	"./script_loader/script_loader_service.ts": 46076,
	"./skin/skin_service.ts": 26453,
	"./spinner_proxy_service/spinner_proxy_service.ts": 49774,
	"./structured_logging/structured_logging_service.ts": 80771,
	"./themes/themes_service.js": 61263,
	"./time/time_service.ts": 86880,
	"./toaster/toaster_proxy_service.ts": 72797,
	"./trackjs/trackjs_service.ts": 23583,
	"./visibility_detector/visibility_detector_service.ts": 55816,
	"./wallet/wallet_service.js": 36882,
	"./web_login/web_login_service.js": 85030,
	"./web_push/web_push_service.ts": 39008,
	"./window/window_service.ts": 33094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10501;